// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EQL_t","right":"Footer_right__1SXGA","buttons":"Footer_buttons__zWjC8"};